import React from 'react'
import { IconType } from './design-constants'

export type IconSize = 'small' | 'large'

const imageUrls = new Map<IconType, string>([
   [IconType.Insight, '/design/icons/icon-insight.svg'],
   [IconType.Warning, '/design/icons/icon-warning.svg'],
])

type Props = {
   iconSize: IconSize
   iconType: IconType
}

const IconCircle = (props: Props) => (
   <span
      className="inline-block rounded-full bg-no-repeat bg-center w-[35px] h-[35px] data-[size=small]:w-[35px] data-[size=small]:h-[35px] data-[size=large]:w-[50px] data-[size=large]:h-[50px] data-[type=warning]:bg-[length:auto_48%] data-[type=warning]:bg-pink91 data-[type=insight]:bg-[length:45%_auto] data-[type=insight]:bg-blue91"
      data-size={props.iconSize}
      data-type={props.iconType}
      style={{
         backgroundImage: `url(${imageUrls.get(props.iconType)})`,
      }}
   />
)

export default IconCircle
